import { useRouterState } from "@tanstack/react-router";
import { PageLayout, PageHero } from "../components/page-shell";
import { Breadcrumbs } from "../components/breadcrumbs";
import { ShieldOutline } from "../components/shield-outline";
import { useTranslation } from "react-i18next";
import { useEffect, lazy, Suspense } from "react";

const LazyContactForm = lazy(() =>
  import("@/lib/contact-dialog").then((m) => ({ default: m.ContactForm })),
);
import { pushEvent, EVENT_CONTACT_PAGE_VIEW } from "@/lib/gtm-events";

const TITLE = "Contact — Plan je gratis demo | IT Solutions";
const DESC =
  "Stuur je URL of brief en ontvang binnen 24 uur een evaluatierapport plus een live demo op je eigen subdomein. hello@itsolutions.be.";

export function ContactPage() {
  const { t } = useTranslation("contact");
  const { t: tp } = useTranslation("pages");
  const search = useRouterState({ select: (s) => s.location.search as Record<string, unknown> });
  const isAudit = search?.type === "audit";
  const isAgencies = search?.type === "agencies";
  const isBeoordeling = search?.type === "beoordeling";
  const packageId = typeof search?.pakket === "string" ? search.pakket : undefined;
  const showPreview = search?.preview === "1" || search?.preview === 1;
  const prefix = isAudit
    ? "form.audit_"
    : isAgencies
      ? "form.agencies_"
      : isBeoordeling
        ? "form.beoordeling_"
        : "form.";
  useEffect(() => {
    pushEvent(EVENT_CONTACT_PAGE_VIEW);
  }, []);
  return (
    <PageLayout>
      <Crumbs pageKey="contact" />
      <PageHero visual="portrait"
        eyebrow={t(`${prefix}eyebrow`)}
        title={t(`${prefix}heading`)}
        sub={t(`${prefix}intro`)}
      />
      <section className="relative overflow-hidden border-b border-border bg-surface/60">
        <ShieldOutline strokeWidth={2} className="absolute -right-10 -bottom-12 h-44 w-36 text-brand/15 md:-right-12 md:-bottom-24 md:h-80 md:w-72" />
        <div className="relative mx-auto max-w-3xl px-6 py-16 md:py-20">
        <div className="rounded-sm border border-border bg-background p-6 md:p-10">
        <Suspense fallback={<div className="h-[640px] rounded-sm bg-surface/30" />}>
          <LazyContactForm
            variant={
              isAudit ? "audit" : isAgencies ? "agencies" : isBeoordeling ? "beoordeling" : "default"
            }
            packageId={packageId}
          />
        </Suspense>
        </div>
        {showPreview ? (
          <a
            href={`/email-preview${packageId ? `?pakket=${encodeURIComponent(packageId)}` : ""}`}
            className="mt-8 inline-block rounded-md border border-border px-3 py-1.5 text-xs font-medium text-muted-foreground transition-colors hover:text-foreground"
          >
            {tp("contact.preview_link")}
          </a>
        ) : null}
        </div>
      </section>
    </PageLayout>
  );
}

function Crumbs({ pageKey }: { pageKey: string }) {
  const { t } = useTranslation("common");
  return <Breadcrumbs items={[{ label: t(`breadcrumbs.pages.${pageKey}`) }]} />;
}
